import React from "react";
import { UserShape } from "../interfaces/classTypes";
let current_user = [];
export class User {
  public id: number;
  public firstName: string;
  public lastName: string;
  constructor(data: UserShape) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.save;
  }
  save() {
    current_user.push(this);
  }
  static userData() {
    return current_user;
  }
}
